// 분석 및 보고서(대표) — 시안 v6 #pg-report · renderReport. 계약 §11.
import { useMemo, useState } from "react";
import AdminGate from "../../v6common/AdminGate";
import { errorText } from "../../inquiry/v6Api";
import { showToast } from "../../../utill/utill";
import * as api from "./api";
import useBlock from "./useBlock";
import { dayKeys, dailyCounts, seoulDate, periodText } from "./format";
import CostPanel from "./CostPanel";
import { PerfPanel, QualityPanel, DailyPanel, HourlyPanel } from "./MetricPanels";
import { LangPanel, CatPanel, TopPanel, FilesPanel } from "./BreakdownPanels";
import "./report.css";

function Report({ go }) {
    const [days, setDays] = useState(30);
    const [busy, setBusy] = useState(false);
    const keys = useMemo(() => dayKeys(days), [days]);

    const summary = useBlock(() => api.getSummary(days), days);
    const cost = useBlock(() => api.getCostDays(keys), days);
    const langs = useBlock(() => api.getLanguages(days), days);
    const cats = useBlock(() => api.getCategories(days), days);
    const top = useBlock(() => api.getTopQuestions(days), days);
    const files = useBlock(() => api.getRecentFiles(), "files");
    // 일별·시간대 대화량은 요약 응답 안에 같이 온다(§11) — 요약 블록 상태를 그대로 쓴다
    const convs = summary.data ? dailyCounts(summary.data.daily_conversations, keys) : null;

    const toChat = (params) => go("chat_history", { ...params, days });

    const exportCsv = async () => {
        if (busy) return;
        setBusy(true);
        try {
            const blob = await api.exportCsv(days);
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `분석보고서_${seoulDate(Date.now())}.csv`;
            a.click();
            setTimeout(() => URL.revokeObjectURL(a.href), 1000);
            showToast(`${periodText(days)} 사용 내역을 엑셀(CSV)로 내려받았습니다.`, "success");
        } catch (e) {
            showToast(errorText(e), "error");
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <div className="top">
                <div><h1>분석 및 보고서</h1><p>챗봇 사용량, API 비용, 품질 지표를 한 화면에서 봅니다</p></div>
                <div className="top-act">
                    <select className="sel" value={days} onChange={(e) => setDays(Number(e.target.value))} aria-label="기간">
                        <option value={1}>오늘</option><option value={7}>지난 7일</option><option value={30}>지난 30일</option>
                    </select>
                    <button type="button" className="btn" onClick={exportCsv} disabled={busy}>
                        <i className="fa-solid fa-file-excel" style={{ color: "#15803d" }}></i>엑셀
                    </button>
                </div>
            </div>
            <CostPanel key={days} days={days} keys={keys} cost={cost} convs={convs} />
            <PerfPanel days={days} summary={summary} />
            <div className="cols2 mt">
                <DailyPanel keys={keys} daily={summary} convs={convs} />
                <QualityPanel summary={summary} />
            </div>
            <div className="cols2 mt">
                <LangPanel langs={langs} onPick={(lang) => toChat({ lang })} />
                <CatPanel cats={cats} onPick={(id) => toChat({ quick_category_id: id })} />
            </div>
            <HourlyPanel hourly={summary} />
            <div className="cols2 mt">
                <TopPanel top={top} onPick={(q) => toChat({ q })} />
                <FilesPanel files={files} onKb={() => go("knowledge")} />
            </div>
        </>
    );
}

export default function ReportPage({ go }) {
    return (
        <main className="inq-r">
            <AdminGate ownerOnly>{() => <Report go={go} />}</AdminGate>
        </main>
    );
}
